import React, { Fragment } from "react";
import TextInput from "../../../common/TextInput";
import JaNeeRadioButtonGroup from "../../../common/JaNeeRadioButtonGroup";
import Row from "../../../common/Row";
import Fieldset from "../../../common/Fieldset";
import PropTypes from "prop-types";
import { TochtTypeIds } from "../../../../constants/DomainConstants";

const VoorzieningenComponent = props => {
	const { model, disabled, onChange, getError, validationMessageType } = props;

	const isFietstocht = model.tochtTypeId === TochtTypeIds.FIETSTOCHT;

	const omschrijvingAandenken = (model.aandenken === true || model.aandenken === "true") ? (
		<TextInput
			label="Beschrijving aandenken"
			name="aandenkenOmschrijving"
			value={model.aandenkenOmschrijving}
			onChange={onChange}
			validationMessage={getError("aandenkenOmschrijving")}
			validationMessageType={validationMessageType}
			disabled={disabled}
		/>
	) : null;

	const kleedkamersStartMV = (model.kleedkamersStart === true || model.kleedkamersStart === "true") ? (
		<JaNeeRadioButtonGroup
			label="Aparte kleedkamers mannen/vrouwen"
			name="kleedkamersManVrouwStart"
			value={model.kleedkamersManVrouwStart}
			optional
			labelInside
			onChange={onChange}
			horizontal
			disabled={disabled}
			size={6}
			validationMessage={getError("kleedkamersManVrouwStart")}
			validationMessageType={validationMessageType}
		/>
	) : null;

	const kleedkamersAankomstMV = (model.kleedkamersAankomst === true || model.kleedkamersAankomst === "true") ? (
		<JaNeeRadioButtonGroup
			label="Aparte kleedkamers mannen/vrouwen"
			name="kleedkamersManVrouwAankomst"
			value={model.kleedkamersManVrouwAankomst}
			optional
			labelInside
			onChange={onChange}
			horizontal
			disabled={disabled}
			size={6}
			validationMessage={getError("kleedkamersManVrouwAankomst")}
			validationMessageType={validationMessageType}
		/>
	) : null;

	const douchesMV = (model.douches === true || model.douches === "true") ? (
		<JaNeeRadioButtonGroup
			label="Aparte douches mannen/vrouwen"
			name="douchesManVrouw"
			value={model.douchesManVrouw}
			optional
			labelInside
			onChange={onChange}
			horizontal
			disabled={disabled}
			size={6}
			validationMessage={getError("douchesManVrouw")}
			validationMessageType={validationMessageType}
		/>
	) : null;

	const voorzieningenStartAankomstSamen = (
		<Fieldset title={"Voorzieningen op de start/aankomstplaats"}>
			<JaNeeRadioButtonGroup
				label="Bewaakte fietsenstalling"
				name="bewaakteFietsstallingStart"
				value={model.bewaakteFietsstallingStart}
				labelInside
				optional
				onChange={onChange}
				horizontal
				disabled={disabled}
				size={6}
				validationMessage={getError("bewaakteFietsstallingStart")}
				validationMessageType={validationMessageType}
			/>
			<JaNeeRadioButtonGroup
				label="Parking"
				name="parkingStart"
				value={model.parkingStart}
				optional
				onChange={onChange}
				horizontal
				labelInside
				disabled={disabled}
				size={6}
				validationMessage={getError("parkingStart")}
				validationMessageType={validationMessageType}
			/>
			<JaNeeRadioButtonGroup
				label="EHBO-post"
				name="ehboStart"
				value={model.ehboStart}
				optional
				onChange={onChange}
				labelInside
				horizontal
				disabled={disabled}
				size={6}
				validationMessage={getError("ehboStart")}
				validationMessageType={validationMessageType}
			/>
			<JaNeeRadioButtonGroup
				label="Drankgelegenheid"
				name="drankgelegenheidStart"
				value={model.drankgelegenheidStart}
				optional
				labelInside
				onChange={onChange}
				horizontal
				disabled={disabled}
				size={6}
				validationMessage={getError("drankgelegenheidStart")}
				validationMessageType={validationMessageType}
			/><Row>
				<JaNeeRadioButtonGroup
					label="Kleedkamers"
					name="kleedkamersStart"
					value={model.kleedkamersStart}
					optional
					labelInside
					onChange={onChange}
					horizontal
					disabled={disabled}
					size={6}
					validationMessage={getError("kleedkamersStart")}
					validationMessageType={validationMessageType}
				/>
				{kleedkamersStartMV}</Row>
			<Row>
				<JaNeeRadioButtonGroup
					label="Douches"
					name="douches"
					value={model.douches}
					optional
					labelInside
					onChange={onChange}
					horizontal
					disabled={disabled}
					size={6}
					validationMessage={getError("douches")}
					validationMessageType={validationMessageType}
				/>
				{douchesMV}</Row>
			{isFietstocht &&
				<Fragment>
					<JaNeeRadioButtonGroup
						label="Herstellingspost"
						name="herstellingspostStart"
						value={model.herstellingspostStart}
						optional
						labelInside
						onChange={onChange}
						horizontal
						disabled={disabled}
						size={6}
						validationMessage={getError("herstellingspostStart")}
						validationMessageType={validationMessageType}
					/>
					<JaNeeRadioButtonGroup
						label="Afspuitstand"
						name="afspuitstand"
						value={model.afspuitstand}
						optional
						labelInside
						onChange={onChange}
						horizontal
						disabled={disabled}
						size={6}
						validationMessage={getError("afspuitstand")}
						validationMessageType={validationMessageType}
					/>
					<Row>
						<JaNeeRadioButtonGroup
							label="Verhuur fiets"
							name="verhuurMTB"
							value={model.verhuurMTB}
							optional
							labelInside
							onChange={onChange}
							horizontal
							disabled={disabled}
							size={6}
							validationMessage={getError("verhuurMTB")}
							validationMessageType={validationMessageType}
						/>
					</Row>
				</Fragment>}
			<Row>
				<JaNeeRadioButtonGroup
					label="Aandenken"
					name="aandenken"
					value={model.aandenken}
					optional
					labelInside
					onChange={onChange}
					horizontal
					disabled={disabled}
					size={12}
					validationMessage={getError("aandenken")}
					validationMessageType={validationMessageType}
				/>
			</Row>
			{omschrijvingAandenken}

			<Row>
				<JaNeeRadioButtonGroup
					label="Andere voorzieningen"
					name="andereVoorzieningenStart"
					value={model.andereVoorzieningenStart}
					labelInside
					optional
					onChange={onChange}
					horizontal
					disabled={disabled}
					size={12}
					validationMessage={getError("andereVoorzieningenStart")}
					validationMessageType={validationMessageType}
				/>
			</Row>
			{model.andereVoorzieningenStart === true || model.andereVoorzieningenStart === "true" ?
				<Row>
					<TextInput
						label="Beschrijving andere voorzieningen"
						name="andereVoorzieningenOmschrijvingStart"
						size={12}
						value={model.andereVoorzieningenOmschrijvingStart}
						onChange={onChange}
						validationMessage={getError("andereVoorzieningenOmschrijvingStart")}
						validationMessageType={validationMessageType}
						disabled={disabled}
					/>
				</Row> : null}
		</Fieldset>
	);

	const voorzieningenStartAankomstApart = (
		<Fragment>
			<Fieldset title={"Voorzieningen op de startplaats"}>
				<JaNeeRadioButtonGroup
					label="Bewaakte fietsenstalling"
					name="bewaakteFietsstallingStart"
					value={model.bewaakteFietsstallingStart}
					labelInside
					optional
					onChange={onChange}
					horizontal
					disabled={disabled}
					size={6}
					validationMessage={getError("bewaakteFietsstallingStart")}
					validationMessageType={validationMessageType}
				/>
				<JaNeeRadioButtonGroup
					label="Parking"
					name="parkingStart"
					value={model.parkingStart}
					optional
					onChange={onChange}
					horizontal
					labelInside
					disabled={disabled}
					size={6}
					validationMessage={getError("parkingStart")}
					validationMessageType={validationMessageType}
				/>
				<JaNeeRadioButtonGroup
					label="EHBO-post"
					name="ehboStart"
					value={model.ehboStart}
					optional
					onChange={onChange}
					labelInside
					horizontal
					disabled={disabled}
					size={6}
					validationMessage={getError("ehboStart")}
					validationMessageType={validationMessageType}
				/>
				<JaNeeRadioButtonGroup
					label="Drankgelegenheid"
					name="drankgelegenheidStart"
					value={model.drankgelegenheidStart}
					optional
					labelInside
					onChange={onChange}
					horizontal
					disabled={disabled}
					size={6}
					validationMessage={getError("drankgelegenheidStart")}
					validationMessageType={validationMessageType}
				/><Row>
					<JaNeeRadioButtonGroup
						label="Kleedkamers"
						name="kleedkamersStart"
						value={model.kleedkamersStart}
						optional
						labelInside
						onChange={onChange}
						horizontal
						disabled={disabled}
						size={6}
						validationMessage={getError("kleedkamersStart")}
						validationMessageType={validationMessageType}
					/>
					{kleedkamersStartMV}</Row>
				{isFietstocht &&
					<Fragment>
						<JaNeeRadioButtonGroup
							label="Herstellingspost"
							name="herstellingspostStart"
							value={model.herstellingspostStart}
							optional
							labelInside
							onChange={onChange}
							horizontal
							disabled={disabled}
							size={6}
							validationMessage={getError("herstellingspostStart")}
							validationMessageType={validationMessageType}
						/>
						<JaNeeRadioButtonGroup
							label="Verhuur fiets"
							name="verhuurMTB"
							value={model.verhuurMTB}
							optional
							labelInside
							onChange={onChange}
							horizontal
							disabled={disabled}
							size={6}
							validationMessage={getError("verhuurMTB")}
							validationMessageType={validationMessageType}
						/>
					</Fragment>}
				<JaNeeRadioButtonGroup
					label="Andere voorzieningen"
					name="andereVoorzieningenStart"
					value={model.andereVoorzieningenStart}
					labelInside
					optional
					onChange={onChange}
					horizontal
					disabled={disabled}
					size={12}
					validationMessage={getError("andereVoorzieningenStart")}
					validationMessageType={validationMessageType}
				/>
				{model.andereVoorzieningenStart === true || model.andereVoorzieningenStart === "true" ?
					<TextInput
						label="Beschrijving andere voorzieningen"
						name="andereVoorzieningenOmschrijvingStart"
						optional
						size={12}
						value={model.andereVoorzieningenOmschrijvingStart}
						onChange={onChange}
						validationMessage={getError("andereVoorzieningenOmschrijvingStart")}
						validationMessageType={validationMessageType}
						disabled={disabled}
					/> : null}
			</Fieldset>
			<Fieldset title={"Voorzieningen op de aankomstplaats"}>
				<JaNeeRadioButtonGroup
					label="Bewaakte fietsenstalling"
					name="bewaakteFietsstallingAankomst"
					value={model.bewaakteFietsstallingAankomst}
					labelInside
					optional
					onChange={onChange}
					horizontal
					disabled={disabled}
					size={6}
					validationMessage={getError("bewaakteFietsstallingAankomst")}
					validationMessageType={validationMessageType}
				/>
				<JaNeeRadioButtonGroup
					label="Parking"
					name="parkingAankomst"
					value={model.parkingAankomst}
					optional
					onChange={onChange}
					horizontal
					labelInside
					disabled={disabled}
					size={6}
					validationMessage={getError("parkingAankomst")}
					validationMessageType={validationMessageType}
				/>
				<JaNeeRadioButtonGroup
					label="EHBO-post"
					name="ehboAankomst"
					value={model.ehboAankomst}
					optional
					onChange={onChange}
					labelInside
					horizontal
					disabled={disabled}
					size={6}
					validationMessage={getError("ehboAankomst")}
					validationMessageType={validationMessageType}
				/>
				<JaNeeRadioButtonGroup
					label="Drankgelegenheid"
					name="drankgelegenheidAankomst"
					value={model.drankgelegenheidAankomst}
					optional
					labelInside
					onChange={onChange}
					horizontal
					disabled={disabled}
					size={6}
					validationMessage={getError("drankgelegenheidAankomst")}
					validationMessageType={validationMessageType}
				/>
				<Row>
					<JaNeeRadioButtonGroup
						label="Kleedkamers"
						name="kleedkamersAankomst"
						value={model.kleedkamersAankomst}
						optional
						labelInside
						onChange={onChange}
						horizontal
						disabled={disabled}
						size={6}
						validationMessage={getError("kleedkamersAankomst")}
						validationMessageType={validationMessageType}
					/>
					{kleedkamersAankomstMV}
				</Row>
				<Row>
					<JaNeeRadioButtonGroup
						label="Douches"
						name="douches"
						value={model.douches}
						optional
						labelInside
						onChange={onChange}
						horizontal
						disabled={disabled}
						size={6}
						validationMessage={getError("douches")}
						validationMessageType={validationMessageType}
					/>
					{douchesMV}</Row>
				{isFietstocht &&
					<Fragment>
						<JaNeeRadioButtonGroup
							label="Herstellingspost"
							name="herstellingspostAankomst"
							value={model.herstellingspostAankomst}
							optional
							labelInside
							onChange={onChange}
							horizontal
							disabled={disabled}
							size={6}
							validationMessage={getError("herstellingspostAankomst")}
							validationMessageType={validationMessageType}
						/>
						<JaNeeRadioButtonGroup
							label="Afspuitstand"
							name="afspuitstand"
							value={model.afspuitstand}
							optional
							labelInside
							onChange={onChange}
							horizontal
							disabled={disabled}
							size={6}
							validationMessage={getError("afspuitstand")}
							validationMessageType={validationMessageType}
						/>
					</Fragment>}
				<Row>
					<JaNeeRadioButtonGroup
						label="Aandenken"
						name="aandenken"
						value={model.aandenken}
						optional
						labelInside
						onChange={onChange}
						horizontal
						disabled={disabled}
						size={12}
						validationMessage={getError("aandenken")}
						validationMessageType={validationMessageType}
					/>
				</Row>
				{omschrijvingAandenken}

				<JaNeeRadioButtonGroup
					label="Andere voorzieningen"
					name="andereVoorzieningenAankomst"
					value={model.andereVoorzieningenAankomst}
					labelInside
					optional
					onChange={onChange}
					horizontal
					disabled={disabled}
					size={12}
					validationMessage={getError("andereVoorzieningenAankomst")}
					validationMessageType={validationMessageType}
				/>
				{model.andereVoorzieningenAankomst === true || model.andereVoorzieningenAankomst === "true" ?
					<TextInput
						label="Beschrijving andere voorzieningen"
						name="andereVoorzieningenOmschrijvingAankomst"
						optional
						size={12}
						value={model.andereVoorzieningenOmschrijvingAankomst}
						onChange={onChange}
						validationMessage={getError("andereVoorzieningenOmschrijvingAankomst")}
						validationMessageType={validationMessageType}
						disabled={disabled}
					/> : null}
			</Fieldset>
		</Fragment>
	);

	return model.aankomstGelijkAanStartPlaats
		? voorzieningenStartAankomstSamen
		: voorzieningenStartAankomstApart;
};

VoorzieningenComponent.propTypes = {
	model: PropTypes.object.isRequired,
	disabled: PropTypes.bool,
	onChange: PropTypes.func.isRequired,
	getError: PropTypes.func.isRequired,
	validationMessageType: PropTypes.string
};

export default VoorzieningenComponent;
